var Haiku = require("@haiku/core");
var _code_deco2_code = require("./../deco2/code.js");
var _code_deco3_code = require("./../deco3/code.js");
var _code_deco1_code = require("./../deco1/code.js");
module.exports = {
  metadata: {
    uuid: "e645986d-a395-46f2-9d2a-6944ec235fb7",
    version: "0.0.1",
    organization: "Tina",
    project: "AnimatorWebsiteIcon6",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon6",
    username: "tina@haiku.ai",
    root: "https://cdn.haiku.ai/0f9a2fb9-3bf3-4c64-9b2d-1a9af15c3253/5c51f21e1f76d3ec3900c58fb722be9bdc65c090/",
    core: "4.5.1",
    title: "Circle",
    type: "haiku",
    relpath: "code/circle/code.js"
  },
  options: {},
  states: { PlayIt: { type: "string", value: "stop", edited: true } },
  eventHandlers: {},
  timelines: {
    Default: {
      "haiku:0bdfc26b7e49": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd",
        strokeDasharray: "3,4",
        strokeLinecap: "round"
      },
      "haiku:Circle-2188d689141ec7f9": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 74.709,
        "sizeAbsolute.y": 78.359,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:16ac00a7d9ef": {
        x1: "11.4598703%",
        y1: "12.6679657%",
        x2: "81.5438343%",
        y2: "86.2801745%"
      },
      "haiku:e42ab2af86ee": { stopColor: "#F75D4A", offset: "0%" },
      "haiku:999e3cab4eb3": { stopColor: "#FFAC39", offset: "100%" },
      "haiku:13920dea9a61": {
        "sizeAbsolute.y": 62,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 62,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeMode.y": 1,
        "translation.x": 37.68600000000001,
        "translation.y": 38.896,
        "style.zIndex": 1,
        "rotation.z": {
          "0": { value: 0, edited: true, curve: "linear" },
          "2000": { value: 6.284, edited: true }
        }
      },
      "haiku:cd9dc09c17e0": {
        stroke: "url(#25b5284f55b7)",
        "translation.x": 1
      },
      "haiku:a08ea14257b8": {
        d:
          "M30.3,60.8 C46.8685425,60.8 60.3,47.3685425 60.3,30.8 C60.3,14.2314575 46.8685425,0.8 30.3,0.8 C13.7314575,0.8 0.3,14.2314575 0.3,30.8 C0.3,47.3685425 13.7314575,60.8 30.3,60.8 Z"
      },
      "haiku:c4bd665c6989": {
        "translation.x": 37.18,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeAbsolute.x": "auto",
        "sizeAbsolute.y": "auto",
        "style.margin": "0",
        "translation.y": 39.339,
        "sizeMode.z": 1,
        "origin.x": 2.509,
        "origin.y": 1.59,
        "style.zIndex": 3,
        playback: {
          "0": {
            value: Haiku.inject(function(PlayIt) {
              return PlayIt;
            }, "PlayIt"),
            edited: true
          }
        },
        "rotation.z": {
          "0": { value: 0, edited: true, curve: "linear" },
          "2000": { value: -6.284, edited: true }
        }
      },
      "haiku:fa506999ac02": {
        "translation.x": 37.36,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeAbsolute.x": "auto",
        "sizeAbsolute.y": "auto",
        "style.margin": "0",
        "translation.y": 38.961,
        "sizeMode.z": 1,
        "origin.x": -1.24,
        "origin.y": 1.717,
        "style.zIndex": 4,
        playback: {
          "0": {
            value: Haiku.inject(function(PlayIt) {
              return PlayIt;
            }, "PlayIt"),
            edited: true
          }
        },
        "rotation.z": {
          "0": { value: 0, edited: true, curve: "linear" },
          "2000": { value: 6.284, edited: true }
        }
      },
      "haiku:7d43d7dbfdbb": {
        "translation.x": 37.59,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeAbsolute.x": "auto",
        "sizeAbsolute.y": "auto",
        "style.margin": "0",
        "translation.y": 38.539,
        "sizeMode.z": 1,
        "origin.x": 0.82,
        "origin.y": -2.221,
        "style.zIndex": 5,
        playback: {
          "0": {
            value: Haiku.inject(function(PlayIt) {
              return PlayIt;
            }, "PlayIt"),
            edited: true
          }
        },
        "rotation.z": {
          "0": { value: 0, edited: true, curve: "linear" },
          "2000": { value: -6.284, edited: true }
        }
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Circle-2188d689141ec7f9",
      "haiku-title": "Circle"
    },
    children: [
      {
        elementName: _code_deco2_code,
        attributes: {
          "haiku-id": "7d43d7dbfdbb",
          "haiku-var": "_code_deco2_code",
          "haiku-title": "Deco2",
          "haiku-source": "./code/deco2/code.js"
        },
        children: []
      },
      {
        elementName: _code_deco3_code,
        attributes: {
          "haiku-id": "fa506999ac02",
          "haiku-var": "_code_deco3_code",
          "haiku-title": "Deco3",
          "haiku-source": "./code/deco3/code.js"
        },
        children: []
      },
      {
        elementName: _code_deco1_code,
        attributes: {
          "haiku-id": "c4bd665c6989",
          "haiku-var": "_code_deco1_code",
          "haiku-title": "Deco1",
          "haiku-source": "./code/deco1/code.js"
        },
        children: []
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "13920dea9a61",
          "haiku-title": "Oval",
          "haiku-source":
            "designs/AnimatorWebsiteIcon6.sketch.contents/slices/Oval.svg"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "5cf392b95547" },
            children: [
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "16ac00a7d9ef",
                  "haiku-title": "linearGradient-1-2db749",
                  id: "25b5284f55b7"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "e42ab2af86ee" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "999e3cab4eb3" },
                    children: []
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: {
              "haiku-id": "0bdfc26b7e49",
              "haiku-title": "Page-1",
              id: "2c4e89bad6fa"
            },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "cd9dc09c17e0",
                  "haiku-title": "Help-icon",
                  id: "e3120eea46d6"
                },
                children: [
                  {
                    elementName: "path",
                    attributes: {
                      "haiku-id": "a08ea14257b8",
                      "haiku-title": "Oval",
                      id: "647ed0d1906f"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon6/code/circle/code.js
// module id = 455
// module chunks = 127651196306611